import React from 'react';
import { Spinner } from 'react-bootstrap';

const TicketsLoadingState = () => {
  return (
    <div className="bg-white border rounded-3 p-5 text-center my-3 shadow-none">
      <Spinner animation="border" variant="primary" size="sm" className="mb-2" />
      <div className="text-600 fw-semibold" style={{ fontSize: '0.86rem' }}>
        Cargando tickets...
      </div>
    </div>
  );
};

export default TicketsLoadingState;
